import React from 'react';

import AddUserModal from 'components/module/AddUserModal';
import { AddUserModalProps } from 'components/module/AddUserModal/AddUserModal.view';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router';
import { AuthServiceInstance } from 'services/authService';

const AddUser = (): JSX.Element => {
  // MARK:- History
  const navigate = useNavigate();

  // MARK:- Mutations
  const addUserMutation = useMutation(AuthServiceInstance.createConsultant, {
    onSuccess: () => {
      navigate('/dashboard/user-management');
    },
  });

  // MARK:- Functions
  function onSubmit(data: { consultantEmail: string }) {
    addUserMutation.mutate({ consultantEmail: data.consultantEmail });
  }

  // MARK:- Render
  const generatedProps: AddUserModalProps = {
    isSubmitting: addUserMutation.isLoading,
    isError: addUserMutation.isError,
    onSubmit,
  };
  return <AddUserModal {...generatedProps} />;
};

export default AddUser;
